module.exports = __webpack_public_path__ + "static/img/1.3b8a84d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/1.png
// module id = d8tn
// module chunks = 1